import React from 'react';
import { TextInput, TextInputProps, View } from 'react-native';

import styles from './input-text.style';
import { useColors } from '../../hooks';
import { useFont } from '../../hooks/lesson-player.context';

interface InputTextProps extends TextInputProps {
  value: string;
  feedback?: boolean;
  onChangeText: (x: string) => void;
}

export function InputText({
  value = '',
  feedback = false,
  onChangeText,
  ...props
}: InputTextProps) {
  const color = useColors();
  const font = useFont();

  return (
    <View
      style={[
        styles.view,
        {
          borderColor: feedback ? color.error : color.onPrimary,
          backgroundColor: color.primaryOpacity,
        },
      ]}
    >
      <TextInput
        style={[
          styles.text,
          {
            ...font.primary.regular,
            color: color.onPrimary,
          },
        ]}
        value={value}
        onChangeText={(x) => onChangeText(x)}
        autoComplete="off"
        autoCapitalize="none"
        autoCorrect={false}
        {...props}
      />
    </View>
  );
}
